











import { Prop, Component, Vue } from "vue-property-decorator";
import { Pace } from "@/types/NewResults";
import AveragePace from "./pace/AveragePace.vue";
import VariationGraph from "./VariationGraph.vue";
import PaceVariationIcon from "@/assets/images/paceVariation.svg?inline";

@Component({
  components: { PaceVariationIcon, AveragePace, VariationGraph }
})
export default class PaceNew extends Vue {
  @Prop() private pace!: Pace;
  @Prop() private duration!: number;
}
